export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/advantage-language.ffca8398-7bba40.svg";